import { memo } from 'react'
import { Box, Button, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DownloadIcon from '@mui/icons-material/Download'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import HistoryIcon from '@mui/icons-material/History'
import useAuthStore from '../../store/authStore'
import { canExportData } from '../../utils/adminPermissions'

function ProductManagementHeader({
  totalCount,
  onBulkBarcodeUpload,
  onBulkEdit,
  onDownloadExcel,
  onOpenDownloads,
}) {
  const adminPermissions = useAuthStore((s) => s.adminPermissions)
  const showDownloadExcel = canExportData(adminPermissions)

  return (
    <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a1a1a', mb: 0.5 }}>
          Product Management
        </Typography>
        <Typography variant="body2" sx={{ color: '#666' }}>
          View, edit, and manage all products
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          startIcon={<CloudUploadIcon />}
          onClick={onBulkBarcodeUpload}
          sx={{
            color: '#e90000',
            borderColor: '#e90000',
            '&:hover': { bgcolor: '#E8F5E9' },
          }}
        >
          Bulk Barcode Upload
        </Button>
        <Button
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={onBulkEdit}
          sx={{
            color: '#e90000',
            borderColor: '#e90000',
            '&:hover': { bgcolor: '#E8F5E9' },
          }}
        >
          Bulk Edit Products
        </Button>
        <Button
          variant="outlined"
          startIcon={<HistoryIcon />}
          onClick={onOpenDownloads}
          sx={{
            color: '#e90000',
            borderColor: '#e90000',
            '&:hover': { bgcolor: '#E8F5E9' },
          }}
        >
          Product Downloads
        </Button>
        {showDownloadExcel ? (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownloadExcel}
            disabled={totalCount === 0}
            sx={{
              color: '#e90000',
              borderColor: '#e90000',
              '&:hover': { bgcolor: '#E8F5E9' },
            }}
          >
            Download Excel
          </Button>
        ) : null}
      </Box>
    </Box>
  )
}

export default memo(ProductManagementHeader)
